module.exports = __webpack_public_path__ + "img/proud.be5030ca.webp";